import * as components from './components';
import palette from './palette';
import shadows from './shadows';
import typography from './typography';
const themeOptionsBase = {
  typography,
  palette,
  components,
  shadows
};
export default themeOptionsBase;